import { Bell, FolderKanban } from 'lucide-react';
import { ricercaEQuesiti } from './ricerca-e-quesiti';
import { ricercaNelleFonti } from './ricerca-nelle-fonti';
import { redazioneDocumenti } from './redazione-documenti';
import { pareriEMemorandum } from './pareri-e-memorandum';
import { revisioneConfronto } from './revisione-confronto';
import { analisiDocumentale } from './analisi-documentale';
import { fogliCalcolo } from './fogli-calcolo';
import { word } from './word';
import { collaborazione } from './collaborazione';
import type { ComingSoonFeature, FeatureContent } from './types';

/**
 * Registry delle macro-funzionalità, nell'ordine di menu e indice: segue il
 * lavoro di studio, dalla domanda al documento che esce dalla porta. In fondo
 * il lavoro di squadra, che non è un passo del flusso ma il modo in cui tutto
 * lo studio ci lavora.
 */
export const FEATURES: FeatureContent[] = [
  ricercaEQuesiti,
  ricercaNelleFonti,
  redazioneDocumenti,
  pareriEMemorandum,
  revisioneConfronto,
  analisiDocumentale,
  fogliCalcolo,
  word,
  collaborazione,
];

export function getFeature(slug: string): FeatureContent {
  const feature = FEATURES.find(f => f.slug === slug);
  if (!feature) throw new Error(`Funzionalità non trovata: ${slug}`);
  return feature;
}

/**
 * Capacità mostrate nella griglia dell'indice accanto alle pagine dedicate,
 * ma senza una pagina propria: la card descrive, non linka.
 */
export const INDEX_EXTRAS: ComingSoonFeature[] = [];

/**
 * Le card della griglia «Cosa puoi fare»: le pagine dedicate più le capacità
 * senza pagina, nell'ordine dell'indice. Le usa l'indice, e ogni pagina
 * funzionalità le ripropone in coda togliendo sé stessa.
 */
export interface IndexCard {
  icon: ComingSoonFeature['icon'];
  title: string;
  description: string;
  href?: string;
}

export const INDEX_CARDS: IndexCard[] = [
  // Prima le pagine, che si aprono; in coda le capacità senza link
  ...FEATURES.map(feature => ({
    icon: feature.blocks[0].icon,
    title: feature.navLabel,
    description: feature.cardDescription,
    href: `/funzionalita/${feature.slug}/`,
  })),
  ...INDEX_EXTRAS.map(extra => ({ ...extra })),
];

/** In arrivo: solo accennate nell'indice /funzionalita, senza pagina dedicata */
export const COMING_SOON: ComingSoonFeature[] = [
  {
    icon: FolderKanban,
    title: 'Progetti',
    description:
      'Raggruppa conversazioni, documenti e analisi per cliente o pratica e riparti sempre dal lavoro già svolto.',
  },
  {
    icon: Bell,
    title: 'Novità di settore',
    description:
      'Ricevi aggiornamenti quando norme, prassi o pronunce rilevanti per il tuo lavoro vengono modificate o pubblicate.',
  },
];
